import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.pug',
  styleUrls: ['./loader.component.scss'],
  standalone: false
})
export class LoaderComponent {
  @Input() hide = true;
  @Input() overlayBackgroundColor = 'rgba(255, 255, 255, 0.5)';

  constructor() { }

}
